export const isDiffProp = (oldObject, newObject, oldProp, newProp = oldProp) => oldObject[oldProp] !== newObject[newProp];

export const getOpenStatusName = (openStatus) => {
  if (openStatus === 1) {
    return 'closed';
  }
  if (openStatus === 2) {
    return 'closed_permanently';
  }

  return 'open';
};
